/* global document */
import React, { createContext, useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import LoadingBar from 'react-top-loading-bar';

export const LoadingContext = createContext({});

const createPortalSSR = (children, containerId) => {
    const [container, setContainer] = useState(null);
    useEffect(() => {
        setContainer(typeof window !== 'undefined'
            ? document.getElementById(containerId)
            : null);
    }, []);
    if (container === null)
        return null;
    return createPortal(
        children,
        container,
    );
};

// The app context provider component
const LoadingContextProvider = ({ children }) => {
    // defaultLoadingContext is returned by the server on the initial render
    const loadingBarRef = useRef(null);
    const startLoading = () => {
        if (!loadingBarRef.current) 
            return;
        loadingBarRef.current.continuousStart();
    };
    const finishLoading = () => {
        if (!loadingBarRef.current) 
            return;
        loadingBarRef.current.complete();
    };
    const contextValue = useMemo(() => ({
        startLoading,
        finishLoading,
    }), [startLoading, finishLoading]);
    return (<LoadingContext.Provider
        value={contextValue}>
        {createPortalSSR(
            <LoadingBar
                color={'var(--action-color)'}
                ref={loadingBarRef}
                suppressHydrationWarning={true}
            />,
            'loading-bar',
        )}
        {children}
    </LoadingContext.Provider>);
};

LoadingContextProvider.propTypes = {
    children: PropTypes.node,
};

export default LoadingContextProvider;